module.exports = __webpack_public_path__ + "media/images/home/icon-hamburger-dark-0df723dd1a5e511c37dbb7243cff4fa1.svg";